import type { DecorationWidgetConfig } from '../../types'

export const widgetConfig: DecorationWidgetConfig = {
  type: 'title',
  name: '标题',
  icon: '题',
  group: '基础组件',
  description: '展示区块标题、副标题和更多入口',
  defaultProps: {
    title: '区块标题',
    subtitle: '',
    showMore: false,
    linkTarget: ''
  }
}
